
import type { SVGProps } from 'react';
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#chevron-left_svg__a)">
      <path fill="#263E6A" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </g>
    <defs>
      <clipPath id="chevron-left_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChevronLeft;
